import {HttpHeader} from "../http-header/http-header";

export interface HttpRequestInit {
  headers?: HttpHeader[];
  body?: any;
}

export interface HttpPollingRequestInit {
  headers?: any;
  method?: string;
  body?: any;
}

/**
 * Class for Request format
*/
export class HttpRequest {
  readonly method: string;
  body?: any;
  headers?: HttpHeader[];

  /**
   * 
   * @param method - type of http method
   * @param reqInit - request object
   * 
   * ```
   * @example
   * const httpRequest = new HttpRequest('POST', {name: 'test', value: 'test_value})
   * ```
   */
  constructor(method: 'DELETE'|'GET'|'POST'|'PUT'|'PATCH', reqInit: HttpRequestInit) {
    this.method = method;
    this.body = reqInit.body;
    this.headers = reqInit.headers;
  }

  /**
   * 
   * @returns - request init object
   * 
   * ```
   * @example
   * const reqInit = toRequestInit()
   * ```
   */
  toRequestInit(): RequestInit {
    const reqInit: RequestInit = {
      method: this.method,
      mode: 'cors',
      cache: 'no-cache'
    };
    reqInit.headers = this.getHeaderInit();
    if(this.hasBody()) {
      reqInit.body = this.getBodyInit();
    }
    return reqInit;
  }

  /**
   * 
   * @returns - body value of the request header
   * ```
   * @example
   * const testObj = this.hasBody();
   * ```
   */
  private hasBody(): boolean {
    return (this.method == 'DELETE' || this.method == 'POST' || this.method == 'PUT' || this.method == 'PATCH');
  }

  /**
   * 
   * @returns - header init object
   * ```
   * @example
   * const header = this.getHeaderInit()
   * ```
   */
  private getHeaderInit(): HeadersInit {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const fetch = require('node-fetch');
    const headerInit = new fetch.Headers();
    if (this.headers) {
      this.headers.forEach((header) => {
        headerInit.append(header.name, header.value);
      });
    }
    return headerInit;
  }

  /**
   * 
   * @returns - stringified body init object
   * ```
   * @example
   * cont getBody = this.getBodyInit()
   * ```
   */
  private getBodyInit(): BodyInit {
    if (this.body) {
      if (typeof this.body === 'object' || typeof this.body === 'boolean' || Array.isArray(this.body)) {
        return JSON.stringify(this.body);
      }
      return (this.body as any).toString();
    }
    return '';
  }

}
